import script from "./ConfigLandingPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigLandingPage.vue?vue&type=script&setup=true&lang=js"

import "./ConfigLandingPage.vue?vue&type=style&index=0&id=689bdb2a&scoped=true&lang=css"
import "./ConfigLandingPage.vue?vue&type=style&index=1&id=689bdb2a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-689bdb2a"]])

export default __exports__